import SupportAPIService from '@/modules/support/services/apiService'

export default class HelpModule {
  constructor() {
  }

  install(Vue) {
    // Services
    Vue.prototype.$apiService.supportService = new SupportAPIService(Vue.prototype.$api, Vue.prototype.$reportingApi)
  }

  getRoutes() {
    return [
      {
        path: '/support',
        name: 'SupportCenter',
        component: () => import('@/modules/support/views/supportCenter.vue'),
        meta: {
          requiresAuth: true,
          title: 'Support Center',
          menuLink: '/support',
          breadcrumbs: [
              { title: 'Home', link: '/'}
          ],
        }
      },
      {
        path: '/support/ticket',
        name: 'SupportTicketNew',
        component: () => import('@/modules/support/views/supportTicketNew.vue'),
        meta: {
          requiresAuth: true,
          title: 'Create Support Ticket',
          menuLink: '/support',
          breadcrumbs: [
              { title: 'Home', link: '/'},
              { title: 'Support Center', link: '/support'}
          ],
        }
      },
      {
        path: '/support/whatsnew',
        name: 'WhatsNew',
        component: () => import('@/modules/support/views/whatsNew.vue'),
        meta: {
          requiresAuth: true,
          title: 'What\'s New',
          menuLink: '/support/whatsnew',
          breadcrumbs: [
              { title: 'Home', link: '/'},
              { title: 'Support Center', link: '/support'}
          ],
        }
      }
    ]
  }
}